/* eslint-disable prefer-destructuring */
export const REACT_APP_GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
export const REACT_APP_YANDEX_MAPS_KEY = process.env.REACT_APP_YANDEX_MAPS_KEY;
